import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { api } from '@/utils/api';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      pollPaymentStatus();
    }
  }, [sessionId]);

  const pollPaymentStatus = async (attempts = 0) => {
    const maxAttempts = 5;
    if (attempts >= maxAttempts) {
      setStatus('timeout');
      return;
    }

    try {
      const response = await api.getPaymentStatus(sessionId);
      if (response.data.payment_status === 'paid') {
        setStatus('success');
        return;
      }
      setTimeout(() => pollPaymentStatus(attempts + 1), 2000);
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center space-y-8">
        {status === 'checking' && (
          <div>
            <div className="w-20 h-20 mx-auto mb-6 border-4 border-champagne-gold border-t-transparent rounded-full animate-spin"></div>
            <h1 className="luxury-text text-3xl font-medium mb-4">Processing Payment...</h1>
            <p className="text-slate-800">Please wait while we confirm your payment</p>
          </div>
        )}
        {status === 'success' && (
          <div>
            <CheckCircle2 className="w-20 h-20 mx-auto mb-6 text-emerald-silk" />
            <h1 className="luxury-text text-3xl font-medium mb-4 text-emerald-silk" data-testid="payment-success-message">Payment Successful!</h1>
            <p className="text-slate-800 mb-8">Thank you for your booking. You will receive a confirmation email shortly.</p>
            <Button
              onClick={() => navigate('/dashboard/client')}
              className="rounded-sm bg-midnight-navy hover:bg-midnight-navy/90"
              data-testid="view-bookings-button"
            >
              View My Bookings
            </Button>
          </div>
        )}
        {status === 'error' && (
          <div>
            <h1 className="luxury-text text-3xl font-medium mb-4 text-red-600">Payment Verification Failed</h1>
            <p className="text-slate-800 mb-8">Please contact support if the amount was deducted.</p>
            <Button onClick={() => navigate('/')} className="rounded-sm bg-midnight-navy hover:bg-midnight-navy/90">
              Go Home
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
